/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AccountValidation",
            "endpoint": "https://b3zlx4byp0.execute-api.ap-northeast-1.amazonaws.com/prd",
            "region": "ap-northeast-1"
        },
        {
            "name": "NotificationApi",
            "endpoint": "https://hb2rzfw87b.execute-api.ap-northeast-1.amazonaws.com/prd",
            "region": "ap-northeast-1"
        },
        {
            "name": "ServiceAccountAPI",
            "endpoint": "https://2uhclgrpg0.execute-api.ap-northeast-1.amazonaws.com/prd",
            "region": "ap-northeast-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://z4gkvc243rcwthbvjzvutrylnu.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "AWS_IAM",
    "aws_cognito_identity_pool_id": "ap-northeast-1:86cc2577-0c4f-42b9-9856-e2a8a8f64fdd",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_kRSDIdYmz",
    "aws_user_pools_web_client_id": "2jtfi3n130gq29v8ts5nrrv7bb",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
